"use strict";
exports.__esModule = true;
exports.isNFTActive = exports.isNftTransaction = void 0;
var env_1 = require("../env");
var isNftTransaction = function (transaction) {
    if (transaction.family === "ethereum") {
        return ["erc721.transfer", "erc1155.transfer"].includes(transaction.mode);
    }
    return false;
};
exports.isNftTransaction = isNftTransaction;
function isNFTActive(currency) {
    return (0, env_1.getEnv)("NFT_CURRENCIES").split(",").includes(currency.id);
}
exports.isNFTActive = isNFTActive;
//# sourceMappingURL=support.js.map